export default __webpack_public_path__ + "static/article-banner-texture-51c4ddcae8a787158e971ffa01bada6a.png";